
/*
 *
 * TriggerTimeline Actions
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 11-Mar-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  // @generator action:route:type
  DO_SHOW_TTL: '@@TriggerTimeline/show_ttl',
  DO_HIDE_TTL: '@@TriggerTimeline/hide_ttl',
  DO_RETRIEVE_TTL: '@@TriggerTimeline/get_retrieve_ttl',
  DO_SET_RETRIEVE_TTL_READ: '@@TriggerTimeline/set_retrieve_ttl_read',
  DO_MARK_NEWS_READ: '@@TriggerTimeline/mark_news_read',
  DO_GET_COMUNICATION_DETAIL: '@@TriggerTimeline/get_comunication_detail',
  DO_RESET_HOME_COMUNICATION: '@@TriggerTimeline/reset_home_comunication',
  DO_GET_KITSTART_DATA: '@@TriggerTimeline/get_kitstart_data',

  ...createRequestTypes('@@TriggerTimeline', 'GET_RETRIEVE_TTL'),
  ...createRequestTypes('@@TriggerTimeline', 'SET_RETRIEVE_TTL_READ'),
  ...createRequestTypes('@@TriggerTimeline', 'MARK_NEWS_READ'),
  ...createRequestTypes('@@TriggerTimeline', 'GET_COMUNICATION_DETAIL'),
  ...createRequestTypes('@@TriggerTimeline', 'GET_KITSTART_DATA')
// @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
* * Insert a description
* @name retrieveTTL
* @return {object} - The action object
*/
export const retrieveTTL = new MakeRequest('TriggerTimeline', 'get_retrieve_ttl')
/** @action request
 * Insert a description
 * @name setRetrieveTTLread
 * @return {object} - The action object
 */
export const setRetrieveTTLread = new MakeRequest('TriggerTimeline', 'set_retrieve_ttl_read')
/** @action request
 * Mark a NEWS as read through its communication detail request.
 * @name markNewsRead
 * @return {object} - The action object
 */
export const markNewsRead = new MakeRequest('TriggerTimeline', 'mark_news_read')
/** @action request
 * Insert a description
 * @name getComunicationDetail
 * @return {object} - The action object
 */
export const getComunicationDetail = new MakeRequest('TriggerTimeline', 'get_comunication_detail')
/** @action request
 * Get KitStart data for TTL popup
 * @name getKitStartData
 * @return {object} - The action object
 */
export const getKitStartData = new MakeRequest('TriggerTimeline', 'get_kitstart_data')
// @generator action:route
/** @action
 * * Insert a description
 * @name RetrieveTTL
 * @return {object} - The payload object
 */
export const doRetrieveTTL = (payload) => createAction(actionTypes.DO_RETRIEVE_TTL, { payload })
/** @action
 * * Insert a description
 * @name SetRetrieveTTLread
 * @return {object} - The payload object
 */
export const doSetRetrieveTTLread = (payload) => createAction(actionTypes.DO_SET_RETRIEVE_TTL_READ, { payload })
/** @action
 * Mark a NEWS as read without opening its communication detail.
 * @name doMarkNewsRead
 * @return {object} - The payload object
 */
export const doMarkNewsRead = (payload) => createAction(actionTypes.DO_MARK_NEWS_READ, { payload })
/** @action
* * Insert a description
* @name ShowPopup
* @return {object} - The payload object
*/
export const doShowTtl = (key, moreInfo) => createAction(actionTypes.DO_SHOW_TTL, { key, moreInfo })
/** @action
* * Insert a description
* @name HideTtl
* @return {object} - The payload object
*/
export const doHideTtl = (payload) => createAction(actionTypes.DO_HIDE_TTL, { payload })
/** @action
 * * Insert a description
 * @name GetComunicationDetail
 *  @return {object} - The payload object
 */
export const doGetComunicationDetail = (payload) => createAction(actionTypes.DO_GET_COMUNICATION_DETAIL, { payload })
/** @action
 * * Insert a description
 * @name ResetHomeComunication
 *  @return {object} - The payload object
 */
export const doResetHomeComunication = (payload) => createAction(actionTypes.DO_RESET_HOME_COMUNICATION, { payload })
/** @action
 * Get KitStart data for TTL popup
 * @name doGetKitStartData
 * @return {object} - The payload object
 */
export const doGetKitStartData = (payload) => createAction(actionTypes.DO_GET_KITSTART_DATA, { payload })
